var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9511 20.5534C24.3438 16.1606 24.3438 9.03859 19.9511 4.64586C15.5584 0.253124 8.43633 0.253125 4.04359 4.64586C-0.349141 9.03859 -0.349141 16.1606 4.04359 20.5534C8.43633 24.9461 15.5584 24.9461 19.9511 20.5534Z",
    fill: "#DB7802"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.088 14.5083C22.2875 19.1921 18.5921 22.8874 13.9085 23.6879L7.85215 17.6316C6.40292 16.4356 5.47925 14.6256 5.47925 12.5998C5.47925 8.99848 8.39862 6.0791 12 6.0791C14.0257 6.0791 15.8357 7.00282 17.0317 8.45201L23.088 14.5083Z",
    fill: "#482701"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94776 12.987L10.8049 14.6924C11.0757 14.9418 11.495 14.9285 11.7498 14.6659L15.0629 11.4938C15.3324 11.2346 15.3405 10.8059 15.0813 10.5363C14.8221 10.2671 14.3936 10.2587 14.1241 10.5178L11.2543 13.2655L9.8652 11.9899C9.59 11.7366 9.16123 11.7544 8.90787 12.0299C8.65456 12.3051 8.67242 12.7336 8.94776 12.987ZM12 6.0791C15.6013 6.0791 18.5207 8.99848 18.5207 12.5998C18.5207 16.2012 15.6013 19.1206 12 19.1206C8.39862 19.1206 5.47925 16.2012 5.47925 12.5998C5.47925 8.99848 8.39862 6.0791 12 6.0791Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPass);
export default __webpack_public_path__ + "static/media/icon_pass.c03b32b70d4d0f03e088af33c50163df.svg";
export { ForwardRef as ReactComponent };